import type { FilterOption } from '../definitions/filter-option';
import type { Observable } from 'rxjs';
import { map } from 'rxjs';
import type { Result } from '@team23/ts-result';

export const generateFilterPlaceholder$ = (filterSource: Observable<Result<Array<FilterOption>, unknown>>): Observable<string> =>
    filterSource
        .pipe(
            map(options =>
                (options.data?.length
                    ? `z.B. ${ options.data[0]?.label }`
                    : ''),
            ),
        );
